import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-bidding-deviation-report-dialog',
  templateUrl: './bidding-deviation-report-dialog.component.html',
  styleUrls: ['./bidding-deviation-report-dialog.component.css']
})
export class BiddingDeviationReportDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<BiddingDeviationReportDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { invitation: any; deviations: any[]; summary: any }
  ) {}

  formatCurrency(amount: number): string {
    return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(amount || 0);
  }

  /** Deviation = estimated amount - bid amount. Positive = bid lower (savings), Negative = bid higher (over) */
  getDeviationAmount(d: { estimated_amount?: number; bidder_amount?: number; amount_deviation?: number }): number {
    if (d.estimated_amount != null && d.bidder_amount != null) {
      return (d.estimated_amount || 0) - (d.bidder_amount || 0);
    }
    return d.amount_deviation != null ? -(d.amount_deviation as number) : 0;
  }

  /** Returns CSS classes for deviation: green (bid lower) / red (bid higher) / neutral (zero) */
  getDeviationClass(deviation: number): string {
    if (deviation > 0) return 'text-green-600 font-medium';   // bid lower than estimated
    if (deviation < 0) return 'text-red-600 font-medium';     // bid higher than estimated
    return 'text-gray-600';
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
